var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Summary'),_c('latest'),_c('a-modal',{attrs:{"footer":null},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('img',{attrs:{"src":_vm.url}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }